import { FormType } from '../../shared/models/form';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface AddTripButtonProps {
  onClick: () => void;
}

const AddTripButton = ({ onClick }: AddTripButtonProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FormType>();
  const {
    errors: { bounds },
  } = useFormState({ control, name: 'bounds' });

  return (
    <div className="md:col-span-4">
      <button
        type="button"
        className="flex gap-x-2 rounded focus:ring-2 focus:ring-gray-500 outline-none ring-offset-2 px-4 py-2.5 text-sm hover:bg-nok-700 text-black font-semibold disabled:opacity-50 disabled:hover:cursor-not-allowed"
        onClick={onClick}
        disabled={bounds?.root?.type === 'maxLength'}
      >
        <svg
          fill="currentColor"
          height="1.2em"
          viewBox="0 0 256 256"
          width="1.2em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z"></path>
        </svg>
        {t('Add trip')}
      </button>
    </div>
  );
};

export default AddTripButton;
